module.exports = __webpack_public_path__ + "media/female_resultB.c997c75e.mp3";